import { FC, memo } from 'react'

import { FF, FormType, LicenseMultiSelect, TextInput, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { ChoiceOption } from 'ui/types'

import { DutchieFormPayload } from '../types'

import * as SC from './styles'

type Props = {
  form: FormType<DutchieFormPayload>
  licensesToAssign: ChoiceOption[]
}

export const DutchieForm: FC<Props> = memo((props) => {
  const { form, licensesToAssign } = props

  return (
    <>
      <SC.Title>Add Dutchie POS</SC.Title>
      <SC.Note>Enter your Dutchie POS API key below</SC.Note>
      <FormRow>
        <Col>
          <form.Field
            name="key"
            validators={{
              onSubmit: ({ value }) => Validators.required.field(value)
            }}
            children={(field) => (
              <FF label="API Key" field={field} required input={(inputProps) => <TextInput {...inputProps} />} />
            )}
          />
        </Col>
        <Col>
          <form.Field
            name="licenseIds"
            validators={{
              onSubmit: ({ value }) => Validators.required.array()(value)
            }}
            children={(field) => (
              <FF
                label="License(s)"
                field={field}
                required
                input={(inputProps) => <LicenseMultiSelect data={licensesToAssign} {...inputProps} />}
              />
            )}
          />
        </Col>
      </FormRow>
    </>
  )
})
